
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

var firebaseConfig = {
    apiKey: "AIzaSyB-BumxuZxet6vaZb8EloxAY5tZlRJXhlY",
    authDomain: "rauru-91579.firebaseapp.com",
    databaseURL: "https://rauru-91579.firebaseio.com",
    projectId: "rauru-91579",
    storageBucket: "rauru-91579.appspot.com",
    messagingSenderId: "103895206915",
    appId: "1:103895206915:web:bcfb7339f9de2d943f9236",
    measurementId: "G-3L945WNF7B"
  };

  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  export default firebase;